import { Paper as MuiPaper, paperClasses as muiPaperClasses } from '@mui/material';
export const Paper = MuiPaper;
export const paperClasses = muiPaperClasses;
